<template>
  <section>
    <div class="row custom-header">
      <div class="col-md-3">
        <span>Messages</span>
      </div>
      <div class="col-md-4"></div>
      <div class="col-md-5 custom-right">
        <button class="btn btn-secondary btn-sm" @click="clearAll">
          Clear All
        </button>
      </div>
    </div>
    <div class="custom-messages">
      <div class="list-group">
        <message-record
          v-for="msg of messages"
          :key="msg.id"
          :msg="msg"
          :tags="tags"
          @view="viewMessage(msg)"
        />
      </div>
      <div v-if="moreCursor !== null" class="custom-more">
        <a href="#" @click="getMore">more</a>
      </div>
    </div>
    <confirm-clear
      :show="actionConfirmClear"
      :confirmTitle="confirmTitleClear"
      :confirmAction="confirmActionClear"
      :confirmQuestion="confirmQuestionClear"
      @closing="closeModal"
      @proceed="performClear"
    />
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import MessageRecord from '@/Components/Coaching/message-record'
import ConfirmClear from '@/Components/ZElements/ConfirmDialog'
export default {
  name: 'wall-messages',
  components: {
    MessageRecord,
    ConfirmClear,
  },
  props: {
    to: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      confirmTitleClear: 'Confirm Clear All',
      confirmActionClear: 'Clear All',
      confirmQuestionClear:
        'Are you sure you wish to clear all un-read messages?',
      actionConfirmClear: null,
    }
  },
  computed: {
    ...mapGetters('users', ['profile']),
    ...mapGetters('coaching', ['wallmessages', 'mergeTags', 'cursorUrl']),
    tags() {
      // let _data = {
      //   firstName: null,
      //   lastName: null,
      //   calories: null,
      //   percentGoal: null,
      // }
      // if (this.mergeTags !== undefined && this.mergeTags !== null) {
      //   if (this.mergeTags['First Name']) {
      //     _data.firstName = this.mergeTags['First Name']
      //   } else if (this.mergeTags['Last Name']) {
      //     _data.lastName = this.mergeTags['Last Name']
      //   } else if (this.mergeTags['Calories']) {
      //     _data.calories = this.mergeTags['Calories']
      //   } else if (this.mergeTags['Percent Goal']) {
      //     _data.percentGoal = this.mergeTags['Percent Goal']
      //   }
      // }
      return this.mergeTags
    },
    moreCursor() {
      let _data = null
      if (this.cursorUrl !== undefined && this.cursorUrl !== null) {
        _data = this.cursorUrl
      }
      return _data
    },
    messages() {
      let _data = []
      if (this.wallmessages) {
        this.wallmessages.forEach((message) => {
          let isRead = false
          let isReadByMe = false
          let readIds = []
          let notifyCoach = 0
          if (message.notify_coach) {
            notifyCoach = parseInt(message.notify_coach)
          }
          if (
            message.read_by !== '' &&
            message.from_coach === 0 &&
            notifyCoach === this.profile.id
          ) {
            if (message.read_by.includes(' ')) {
              readIds = message.read_by.split(' ')
              if (readIds.includes(this.to.id.toString())) {
                isRead = true
              }
              if (readIds.includes(this.profile.id.toString())) {
                isReadByMe = true
              }
            } else {
              if (message.read_by === this.to.id.toString()) {
                isRead = true
              }
              if (message.read_by === this.profile.id.toString()) {
                isReadByMe = true
              }
            }
          } else if (message.from_coach === 1) {
            isRead = true
            isReadByMe = true
          } else if (notifyCoach !== this.profile.id) {
            isRead = true
            isReadByMe = true
          }
          let position = 'left'
          if (message.email === this.profile.email) {
            position = 'right'
          }
          let regex = /<br\s*[\/]?>/gi
          let msg = message.text.replace(regex, ' ')
          _data.push({
            id: message.id,
            isread: isRead,
            isreadByMe: isReadByMe,
            starred: message.starred,
            text: msg,
            created: message.created_at,
            to: {
              id: this.to.id,
              lastName: this.to.lastName,
              firstName: this.to.firstName,
              avatar: this.to.avatar,
              percentGoal: message.percent_goal,
              calories: message.calories,
              mealsTracked: message.meals_tracked,
            },
            avatar: message.avatar,
            name: message.name,
            position: position,
            attachments: message.attachments,
          })
        })
      }
      console.log('Wall Messages', {
        incomingMessages: this.wallmessages,
        processedMessages: _data,
      })
      return _data
    },
  },
  methods: {
    ...mapActions('coaching', [
      'setWallMessage',
      'setReadMessage',
      'clearAllUnread',
    ]),
    closeModal() {
      this.actionConfirmClear = null
    },
    clearAll() {
      this.actionConfirmClear = true
    },
    async performClear() {
      let data = {
        id: this.to.id.toString(),
      }
      await this.clearAllUnread(data)
      this.actionConfirmClear = null
    },
    viewMessage(msg) {
      this.$emit('beforeView')
      let data = {
        userid: this.profile.id,
        msg: msg,
      }
      console.log('Viewing Message', data)
      this.setWallMessage(data)
      data = {
        messageId: msg.id,
        id: this.profile.id,
      }
      this.setReadMessage(data)
      this.$emit('view', data)
    },
    getMore() {
      this.$emit('refresh')
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-header {
  margin-bottom: 10px;
  border-bottom: 1px solid #dee2e6;
  padding-bottom: 5px;
}
.custom-messages {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 410px;
}
.custom-more {
  margin-top: 5px;
  width: 100%;
  text-align: center;
  a {
    cursor: pointer;
    text-decoration: none;
  }
}
.custom-right {
  text-align: right;
}
</style>
